import { Box, Button } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { salesManagement } from "../../../config";
import { useNavigate } from "react-router-dom";
import { PurchaseOrderItemsColumns } from "../../../data/DynamicTable/Collumns";
import PurchaseOrderItemsForm from "./form";

function PurchaseOrderItemsTable() {
  const navigate = useNavigate();
  const data = JSON.parse(localStorage.getItem("PurchaseOrderData"));
  const base_url = salesManagement.uri;
  
  // Check if the purchase order is reversed
  const isReversed = data?.reversed === 1 || data?.reversed === true;
  const actions = {
    entity: "PurchaseOrderItems",
    isSubRight: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      inputObjectName: "",
      inputSubObjectName: null,
      Show_Button: false,
      permission: "ActivatePermission",
    },
    ViewDistribution: {
      key: "VIEWDISTRIBUTION",
      button_name: "Distribution",
      // Hide Distribution button if reversed is 1 or true
      Show_Button: !isReversed,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    showMore: {
      key: "SHOWMORE",
      button_name: "Show More",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      title: "Purchase Order Details"
    },
    ReversePurchaseOrderItem: {
      key: "MARK_TASK_DONE",
      button_name: "Reverse Purchase Order Item",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    dataObject: {
      inputFields: { purchaseOrderId: data.id },
      inputObjectName: "purchaseOrderItemViewById",
      inputSubObjectName: "purchaseOrderItemView",
      returnFields: [
        "id",
        "purchaseOrderId",
        "productCode",
        "aliasProductName",
        "productId",
        "cartons",
        "productName",
        "orderDate",
        "amount",
        "uomId",
        "quantity",
        "vendorId",
        "vendorName",
        "expiryDate",
        "quantityPerCarton",
        "stockDueDate",
        "addedBy",
        "modifiedBy",
        "minShoeSize",
        "maxShoeSize",
        "isExternalWarehouse",
        "vendorComments",
        "isWarehouseDistributed",
        "isRetailDistributed",
        "reversed",
        "buyingPricePerCarton",
        "sellingPricePerCarton",
        "buyingPricePairs",
        "sellingPricePairs",
        "reorderPoint"
      ],
    },
    showStatus: true,
    showDelivery: false,
    showPayments: false,
  };
  
  const ignore = ["isActive", "companyId", "vendorId", "id", "uomId", "productId", "purchaseOrderId"];
  const ignoreshowMore = ["isActive", "companyId", "vendorId", "id", "uomId", "productId", "purchaseOrderId"];
  
  return (
    <Box m="2px">
      {/* Back Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(-1)}
        sx={{ marginBottom: "10px" }}
      >
        Back
      </Button>
      
      {/* Dynamic Table */}
      <DynamicTable
        title="Purchase Order Items"
        subtitle="Create, view or edit account Purchase Order Items"
        ignoreFields={ignore}
        ignoreShowMore={ignoreshowMore}
        FormComponent={PurchaseOrderItemsForm}
        columns={PurchaseOrderItemsColumns}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default PurchaseOrderItemsTable;